import React, { useState, useCallback } from 'react';
import { Popover, Button, Input, message } from 'antd';
import { getRecommendCheckedRemark, updateRecomendCheckedRemark } from '../../../../service/report';
import './style.scss';

const { TextArea } = Input;

// 核赔推荐按钮
export default function RecommendCheckedBtn(props) {
  const [remark, setRemark] = useState('');
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const getRemarkByRecommendReport = useCallback(() => {
    getRecommendCheckedRemark({ flowId: props.flowId }).then(({ result }) => {
      setVisible(true);
      setRemark(result.remark)
    }).catch(() => {
      setVisible(true)
    })
  }, [props.flowId])

  const updateRemarkByRecommendRport = useCallback(() => {
    if (!remark) {
      message.error('请先输入核赔推荐备注');
      return;
    }
    setLoading(true);
    updateRecomendCheckedRemark({
      flowId: props.flowId,
      remark
    }).then(() => {
      setVisible(false);
      setLoading(false);
      message.success('修改成功');
    }).catch(() => { setLoading(false) });
  }, [props.flowId, remark]);

  return <Popover title="该案件为核赔推荐" trigger="click" visible={visible} placement="topRight" onVisibleChange={() => setVisible(false)} content={<div className="recommend-remark">
    <p className="recommend-remark-title">当前案件在已定损（或重新打款）状态，已持续大于7天未核赔打款，请与保司核实打款状态。核实后若保司核心状态已发生变化，请联系IT部门进行数据修正。</p>
    <TextArea placeholder="若有其他异常，可输入描述，限200字" value={remark} onChange={({ target }) => setRemark(target.value)} maxLength={200} />
    <div style={{ textAlign: 'right', marginTop: 10 }}>
      <Button type="primary" size="small" onClick={updateRemarkByRecommendRport}>确定</Button>
    </div>
  </div>} overlayStyle={{ width: '470px' }}>
    <Button type="text" onClick={getRemarkByRecommendReport} loading={loading}>核赔推荐</Button>
  </Popover>
}